import React, { Component, useEffect, useState } from 'react';
import CardView from './MyCardsView';
import crmservices from '../../wsclient'
import AddCard from './AddCard';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import { newGUID } from '../../utils/util';
import { setAddCardInfo } from '../../utils/common';
import { portalCfg } from '../../../portal.router.config';

// accountt 
// sb-zohys7237983@business.example.com
// M;SB31?x
// EJ37VS8BQHJVA
// sb-2vtnz7239030@personal.example.com
// 0pB{^r7P
// RB7JN2DTVU566
// sb-xtymq7240364@personal.example.com
// 2Oasr!Sz
// 5Z3ABHFRWGEMY

function MyCards(props) {
    const [cards, setCards] = useState([]); 
    const [openAddCard, setOpenAddCard] = useState(false);
    const [message, setMessage] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [html_add_card_content, setHtmlAddCardContent] = useState(null);
    const [showFormStripe, setShowFormStripe] = useState(false);

    useEffect(()=>{
        onLoadPaymentMethods();
    },[]);


    const onLoadPaymentMethods = async(isRefresh) =>{
        onShowLoading(true);
        let paypals = [];
        try {
            let result = await crmservices.contacts.getListPaymentMethods();
            console.log("onLoadPaymentMethods result==", result);
            if (result.code == 'OK') {
                let paymentMethods = result.data.content;
                setCards(paymentMethods);
                paypals = paymentMethods.filter(paymentMethod => paymentMethod.name === 'PayPal');
            }
        } catch (error) {
            console.log("on load payment method exception:", error);
        }
        onShowLoading(false);
        return paypals;
    }

    const setPrimaryCard = async(paymentMethodID) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.setPrimaryCard(paymentMethodID);
            console.log("result setPrimaryCard===", result);
            if (result.code == 'OK') {
                await onLoadPaymentMethods();
                showMessage(true, t('You have successfully set this card as primary'));
                if(props.fromOrder){
                    props.onCloseItem();
                }
            }
            else {
                if(result.data && result.data.error === 'COM.CRM.EXCEPTIONS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION'){
                    showMessage(true, result.data.message ? result.data.message : t('EXCEPTION_PROCESS'));
                }
                else showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onRemoveCard = async (card) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.removePaymentMethod(card.id);
            //console.log(' onRemoveCard card==', card)
            if (result.code == 'OK') {
                await onLoadPaymentMethods();
                showMessage(true, t('REMOVE_CARD_SUCCESS'));
            } else {
                showMessage(true, t('FAILED_TO_REMOVE_CARD'));
            }
        } catch (ex) {
            console.log("remove card exception:", ex);
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const onOpenAddCard = async() =>{
        onShowLoading(true)
        try {
            let token = newGUID();
            let responseURL = window.location.origin + portalCfg.basename + '/process_addcard/' + token;
            console.log(' onPrepareForm responseURL===', responseURL)
            let result = await crmservices.contacts.createFormToAddCard(responseURL);
            console.log(' onPrepareForm result===', result)
            if (result.code == 'OK') {
                //window.document.write(result.data);
                setAddCardInfo({token: token});
                setHtmlAddCardContent(result.data);
                setOpenAddCard(true)  
            }
        } catch (error) {
            console.log("on create form to add card exception:", error);
        }
        onShowLoading(false);
    }
    const onCloseAddCard = () =>{
        onLoadPaymentMethods();
        setOpenAddCard(false);
    }
    const showMessage = async (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    return (
        <div>
            <CardView
                open = {props.open}
                onCloseItem = {props.onCloseItem}
                showLoading = {showLoading} 
                showFormStripe={showFormStripe}
                cards={cards.filter(card => card.payment_method_type === 'CARD' && card.name !== 'STRIPE' && card.name !== 'FAC')}
                paypals={cards.filter(card => card.name && card.name.toLowerCase() === 'paypal')}
                stripes={cards.filter(card => card.name && card.name === 'STRIPE')}
                facs={cards.filter(card => card.name && card.name === 'FAC')}
                onOpenAddCard = {onOpenAddCard}
                setPrimaryCard = {setPrimaryCard}
                onRemoveCard = {onRemoveCard}
                showMessage={showMessage}
                onRefresh={onLoadPaymentMethods}
                setShowFormStripe={setShowFormStripe}
                setOpen={props.setOpen}/>
            {openAddCard && <AddCard
                open = {openAddCard}
                onClose = {onCloseAddCard} 
                html_add_card_content = {html_add_card_content}   />}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
        </div>
    );
}

export default MyCards;